import { render, staticRenderFns } from "./BookingEvents.vue?vue&type=template&id=0c26e260&scoped=true&lang=html&"
import script from "./BookingEvents.vue?vue&type=script&lang=js&"
export * from "./BookingEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c26e260",
  null
  
)

export default component.exports